import { capitalize, upperCase } from 'lodash';
import { TestInstanceResponseInputType } from 'services/assist-api/entities/test-instance-response/types';

/**
 * Returns a human readable version of the response mode.
 */
export function friendlyMode(mode: TestInstanceResponseInputType): string {
  if (mode === TestInstanceResponseInputType.Ai) {
    return upperCase(TestInstanceResponseInputType.Ai);
  }

  return capitalize(mode);
}

/*
 * Returns a list of human readable response modes.
 */
export function friendlyModes(modes: TestInstanceResponseInputType[]): string {
  return modes.map((m) => friendlyMode(m)).join(', ');
}
